import { getS3Url, MediaOpts } from '../get-s3-url';
import { getUserPath } from './get-path';

export const getUserS3Url = (userId: string, key?: string, opts?: MediaOpts) =>
  getS3Url(key ? getUserPath(userId, key) : undefined, opts);
